
import { Component, Prop, Vue } from 'vue-property-decorator';
import Dialog from '@/components/Dialog.vue';
import api from '@/api';
import Swal from 'sweetalert2';

const { member } = api;

@Component({ components: { Dialog } })
export default class UserAddPoint extends Vue {
  @Prop() private userId!: string;

  private loading = false;

  private valid = false;

  private pointValue = 0;

  private remark: string | null = null;

  private requiredRule(column: string) {
    return (v: any) => !!v || `${column} 為必填`;
  }

  private async ok() {
    if ((this.$refs.form as any).validate()) {
      this.loading = true;

      const parameter = { pointValue: this.pointValue, remark: this.remark };
      const { status, message } = await member.addPoints(this.userId, parameter);

      if (status) {
        await Swal.fire({
          title: '操作完成',
          icon: 'info',
        });
        await this.back();
      }

      this.loading = false;
    }
  }

  private async back() {
    await this.$router.back();
  }
}
